import { withFormsy } from 'formsy-react';
import Checkbox from './checkbox';

const CheckboxWithFormsy = withFormsy(Checkbox);

export default CheckboxWithFormsy;
